import React, {FC, useEffect, useState} from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import { Chart, registerables } from 'chart.js';
import ButtonSecondary from "components/Button/ButtonSecondary";

const chartDays = [
  {
    label: "24 Hours",
    value: 1,
  },
  {
    label: "30 Days",
    value: 30,
  },
  {
    label: "3 Months",
    value: 90,
  },
  {
    label: "1 Year",
    value: 365,
  },
];

export interface CoinInfoProps{
  className?: string;
  coin: string;
}

Chart.register(...registerables);

const CoinInfo:FC<CoinInfoProps> = ({ coin }) => {
  const [historicData, setHistoricData] = useState<any>();
  const [days, setDays] = useState(1);


  const fetchHistoricData = async () => {
    const historicDataURL = `https://api.coingecko.com/api/v3/coins/${coin}/market_chart?vs_currency=gbp&days=${days}`;
    const { data } = await axios.get(historicDataURL);
    setHistoricData(data.prices);
  };

  useEffect(() => {
    setHistoricData([]);
    fetchHistoricData();
  }, [days]);

  const minTwoDigits = (n: number) => {
    return (n < 10 ? "0" : "") + n;
  }
  return (
    <div >
      {!historicData ?
        (
          //TODO: FRONT END TO INSERT LOADER
          <>Fetching data...</>
        ) :
        (
          <>
            <Line
              data={{
                labels: historicData?.map((coin: any) => {
                  let date = new Date(coin[0]);
                  let time =
                    date.getHours() > 12
                      ? `${minTwoDigits(date.getHours() - 12)}:${minTwoDigits(date.getMinutes())} PM`
                      : `${minTwoDigits(date.getHours())}:${minTwoDigits(date.getMinutes())} AM`;
                  return days === 1 ? time : date.toLocaleDateString();
                }),
                datasets: [{
                  data: historicData.map((coin: any) => coin[1]),
                  label: `Price ( Past ${days === 1 ? "Day" : `${days} Days`} ) in gbp`,
                  borderColor: "#4338ca",
                }]}}
              options={{
                plugins: {
                  title: {
                    display: true,
                    text: `${coin}`,
                  }
                },
                elements: {point: {
                  radius: 1
                  }
                },
                interaction: {
                  mode: "index",
                  intersect: false,
                },
                scales: {
                  x: {
                    display: true,
                    title: {
                      display: true,
                      text: "Time"
                    }
                  },
                  y: {
                    display: true,
                    title: {
                      display: true,
                      text: "Price"
                    }
                  }
                }
            }}

            />
            <div
              style={{
                display: "flex",
                marginTop: 20,
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              {chartDays.map((day) => (
                <ButtonSecondary
                  key={day.value}
                  onClick={() => setDays(day.value)}
                  selected={day.value === days}
                  coin={coin}
                >
                  {day.label}
                </ButtonSecondary>

              ))}
            </div>
          </>
        )
      }
    </div>
  );
};

export default CoinInfo;
